var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-tab-card',{attrs:{"tabs":_vm.tabs,"title":"Ekonomi"},on:{"visitedTabs":_vm.visitedTabs}})}
var staticRenderFns = []

export { render, staticRenderFns }